import { Badge } from "./ui/badge";

const colors: Record<string, string> = {
  queued: "bg-amber-100 text-amber-800",
  leased: "bg-cyan-100 text-cyan-800",
  running: "bg-blue-100 text-blue-800",
  stopped: "bg-slate-100 text-slate-700",
  stale: "bg-amber-100 text-amber-800",
  missing: "bg-orange-100 text-orange-800",
  unreachable: "bg-rose-100 text-rose-800",
  online: "bg-emerald-100 text-emerald-800",
  success: "bg-emerald-100 text-emerald-800",
  failed: "bg-rose-100 text-rose-800"
};

export function StatusBadge({ status }: { status?: string | null }) {
  const value = status || "none";
  return <Badge className={colors[value] || "bg-slate-100 text-slate-700"}>{value}</Badge>;
}
